import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ActivityItem from '../../components/Common/ActivityItem/ActivityItem';
import { getActivities } from '../../services/associate/associateService';
import { WelletContext } from '../../context/WelletContext';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import { CircleSpinner } from 'react-spinners-kit';

const ActivityList = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem('language') || 'es';
  const welletContext = useContext(WelletContext);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async (page = 1, append = false) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const response = await getActivities(welletContext, page);

      if (append) {
        setActivities((prev) => [...prev, ...response.items]);
      } else {
        setActivities(response.items);
      }

      setHasMore(page < response.totalPages);
      setError(null);
    } catch (err) {
      setError(t('common.errorLoadingData'));
      console.error('Error fetching activities:', err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchActivities(nextPage, true);
  };

  if (loading) {
    return (
      <div className='loaderDiv'>
        <CircleSpinner
          className='spinner-app mx-auto'
          style={{ margin: 'auto' }}
          size={40}
          color='var(--color-font-primary)'
        />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Header pathName='/' title={t('yourLastActivity')} hasBackground={true} showBack={true} />
      <ContentApp>
        <div className='mt-3'>
          {activities.map((activity, index) => (
            <ActivityItem key={index} activity={activity} language={language} />
          ))}
        </div>
        {loadingMore ? (
          <div className='p-4 d-flex justify-content-center'>
            <CircleSpinner className='spinner-app mx-auto' style={{ margin: 'auto' }} size={30} />
          </div>
        ) : hasMore ? (
          <div className='mt-2'>
            <button className='account-button w-100 fw-600' onClick={handleLoadMore}>
              {t('showMoreActivities')}
            </button>
          </div>
        ) : null}
      </ContentApp>
    </>
  );
};

export default ActivityList;
